import DescriptionList from './description-list.vue';
import Description from './description.vue';
DescriptionList.Description = Description;

export default DescriptionList;


// WEBPACK FOOTER //
// ./src/components/description-list/index.js